<template>
  <div>
    <div v-if="!!schema.recipient && !!schema.jst" class="mt-2">
      <recipient-transfer-files :model="schema.recipient" :jst-model="schema.jst" :terc="terc" @change="clearTexts" />
    </div>

    <div v-if="!!schema.decision" class="mt-2">
      <w-wysiwyg :model="schema.decision" :config="decisionConfig" />
    </div>

    <div v-if="!!schema.judgment" class="mt-2">
      <w-wysiwyg :model="schema.judgment" :config="judgmentConfig" />
    </div>

    <div v-if="!!schema.reason" class="mt-2">
      <w-wysiwyg :model="schema.reason" :config="reasonConfig" />
    </div>

    <div v-if="!!schema.recivers" class="mt-2">
      <w-wysiwyg :model="schema.recivers" :config="toInformConfig" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import RecipientTransferFiles from './components/RecipientTransferFiles';

// @vuese
// Formularz uzasadnienia
// @group ActionData
export default {
  components: { ...components, RecipientTransferFiles },
  props: {
    // schema
    schema: { type: Object, required: true },
    // Dane zewnętrzne
    external: { type: Object, required: true }
  },
  data() {
    return {
      // Konfiguracja decyzji
      decisionConfig: { allowedContent: true, height: 150 },

      // Konfiguracja orzeczeń
      judgmentConfig: { allowedContent: true, height: 150 },

      // Konfiguracja uzasadnień
      reasonConfig: { allowedContent: true, height: 150 },

      // Konfiguracja sekcji "otrzymują"
      toInformConfig: { allowedContent: true, height: 100 }
    };
  },

  computed: {
    terc() {
      if (this.external?.document?.data?.applicant?.address?.terc?.length >= 6) {
        return this.external?.document?.data?.applicant?.address?.terc?.slice(0, 6);
      }
    }
  },

  watch: {
    'schema.attachmentIds.$value.length'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.clearRecivers();
      }
    }
  },

  methods: {
    // @vuese
    // Czyści teksty zależne od jednostki/osoby kierującej jednostką
    clearTexts() {
      this.schema.judgment.$setDefault();
    },

    // @vuese
    // Czyści wartość pola `recivers` (załączniki)
    clearRecivers() {
      this.schema.recivers.$setDefault();
    }
  }
};
</script>
